import React, {useEffect, useState} from 'react'
import {Routes, Route, Outlet, useParams, useNavigate, Navigate, matchPath, useLocation} from 'react-router-dom'
import {useAuth} from "../../../providers/AuthProvider";
import SupplierFormItemProvider from "../providers/SupplierFormItemProvider";
import ServiceOfferingsForm from "./ServiceOfferingsForm";
import {Button} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import LoadingSpinner from "../../../components/LoadingSpinner";
import SupplierServiceOfferingFormItemProvider from "../providers/SupplierServiceOfferingFormItemProvider";
import {
    ServiceCategoryStep,
    OverviewStep,
    SearchTagsStep,
    DeliverablesStep,
    FAQsStep,
    RelatedProjectsStep, ServiceNameStep
} from "./ServiceOfferingWizardSteps";
import {useEffectOnce, useMount} from "react-use";
import {ProfileServiceRow} from "../../profiles/sections/AgencyProfileServicesOffered";
import Client from "../../../models/Client";
import ServiceOffering from "../../../models/ServiceOffering";
import Loading from "../../auth/Loading";



// Parent component for individual service offering wizard
const ServiceOfferingWizardParent = ({supplierOrg, onChange, onSave, isDisabled, isUpdating}) => {
    const {serviceOfferingIndex} = useParams();
    const navigate = useNavigate();

    const getModelFromProps = (offering) => {
        let {
            industries = [], skills = [], disciplines = [], brands = [], ...model
        } = {...(offering || {})};

        industries = TB.map(industries, item => ({...item, type: 'industries', value: `industry-${parseInt(item.id)}`}));
        skills = TB.map(skills, item => ({...item, type: 'skills', value: `skill-${parseInt(item.id)}`}));
        disciplines = TB.map(disciplines, item => ({
            ...item,
            type: 'disciplines',
            value: `discipline-${parseInt(item.id)}`
        }));

        return {...(offering || {}), industries, skills, disciplines, brands};
    };

    const offeringIndex = parseInt(serviceOfferingIndex);
    const rawOffering = (supplierOrg.service_offerings || [])[offeringIndex];

    useEffectOnce(() => {
        if (!rawOffering) {
            console.log('offering', rawOffering)
            // navigate('/supplier/manage-profile/service-offerings/', {replace: true})
        }
    });

    console.log('ServiceOfferingWizardParent', rawOffering)
    // if (!rawOffering) {
    //     return <Navigate to={'/supplier/manage-profile/service-offerings/'} replace={true} />;
    // }

    const offering = getModelFromProps(rawOffering);


    const formatPropsForRequest = offering => {
        let tagTypes = ['disciplines', 'skills', 'industries'];
        let formatted = TB.pick(offering, [
            'id',
            ...tagTypes,
            'brands',
            'name',
            'tag_line',
            'summary',
            'process',
            'fee_type',
            'fee_amount',
            'image_path',
            'key_clients',
            'service_tags',
            'deliverables',
            'faqs',
            'display_index',
        ]);
        TB.map(tagTypes, type => {
            formatted[type] = TB.map(formatted[type] || [], item => TB.pick(item, ['id']));
        });
        formatted.brands = TB.map(formatted.brands || [], item => TB.pick(item, ['id', 'domain', 'name','icon','is_custom']));

        return formatted;
    };

    return (
        <SupplierServiceOfferingFormItemProvider
            itemIndex={offeringIndex}
            onChange={offeringProps => {
                let changedModel = TB.cloneDeep(offering);
                for (let [key, value] of Object.entries(offeringProps)) {
                    changedModel = TB.set(changedModel, key, value);
                }
                return changedModel;
            }}
            onSave={async (serviceOfferingProps) => {
                console.log('serviceOfferingPropss', serviceOfferingProps);

                if (!serviceOfferingProps) {
                    let offerings = TB.filter([...supplierOrg?.service_offerings], (serviceOffering, serviceOfferingIndex) => {
                        return offeringIndex !== serviceOfferingIndex;
                    });
                    if (offering?.id) {
                        offerings = TB.map(offerings, offering => formatPropsForRequest(offering));
                        return onSave({service_offerings: offerings}, true);
                    }
                    await onChange({service_offerings: offerings});
                } else {
                    let offerings = TB.set([...supplierOrg?.service_offerings], offeringIndex, serviceOfferingProps);

                    await onChange({service_offerings: offerings});
                    offerings = TB.map(offerings, offering => formatPropsForRequest(offering));

                    return onSave({service_offerings: offerings}, true);
                }
            }}
            model={offering}
            isUpdating={isUpdating}
            isEditing={true}
            onEditing={(toggle) => {
                if (!toggle) {
                    console.log('toggle')
                    navigate('./../../');
                }
            }}
            displayName="Service Offering"
            itemPropName="service_offerings">

            <Outlet />

        </SupplierServiceOfferingFormItemProvider>
    );
};

const ServiceOfferingsStep = React.forwardRef(({supplierOrg, onChange, onSave, onEditItem, isDisabled,
                                  isUpdating, ...props}, formRef) => {

    const {auth} = useAuth();

    const [editingIndex, setEditingIndex] = useState(false);
    const navigate = useNavigate();

    const location = useLocation();
    const currentServiceOfferingsModel = () => {
        if (!supplierOrg) {
            return null;
        }
        // Remove any unsaved serviceOfferings
        let validOfferings = TB.filter(TB.cloneDeep(supplierOrg?.service_offerings || []), ({id}) => !!id);
        return {service_offerings: ServiceOffering.makeMany(validOfferings)}
    }
    const [model, setModel] = useState(() => currentServiceOfferingsModel());
    const matchOffering = matchPath({path: '/supplier/manage-profile/service-offerings/:serviceOfferingIndex/*'}, location.pathname);


    useEffect(() => {
        const match = matchPath({path: '/supplier/manage-profile/service-offerings'}, location.pathname);

        if (match) {
            console.log('RESETTING ServiceOfferings')
            setModel(currentServiceOfferingsModel());
            onEditItem(false)
            setEditingIndex(false)
        }

    }, [location.pathname]);

    console.log('Changing', editingIndex)
    useMount(async () => {
        await TB.wait(200)

        console.log('matchoffering ', matchOffering)
        if (matchOffering?.params?.serviceOfferingIndex && editingIndex === false) {

            console.log('redirecting')
            await onEditItem(false)
            return navigate('/supplier/manage-profile/service-offerings', { replace: true });
        }
    })
    const addNewArrayProp = async (propName) => {
        let models = TB.get({...supplierOrg}, propName, []);
        const newOffering = {
            name: '',
            tag_line: '',
            summary: '',
            process: '',
            fee_type: null,
            fee_amount: null,
            image_path: '',
            disciplines: [],
            skills: [],
            industries: [],
            service_tags: [],
            brands: [],
            deliverables: [],
            key_clients: [],
            faqs: [],
            display_index: models.length
        };
        models.push(newOffering);

        await setModel({service_offerings: models});
        await onEditItem(true)
        return navigate(`${models?.length - 1}`);
    };

    const getModelFromProps = (offering) => {
        let {
            industries = [], skills = [], disciplines = [], brands = [], ...model
        } = {...(offering || {})};

        industries = TB.map(industries, item => ({...item, type: 'industries', value: `industry-${parseInt(item.id)}`}));
        skills = TB.map(skills, item => ({...item, type: 'skills', value: `skill-${parseInt(item.id)}`}));
        disciplines = TB.map(disciplines, item => ({
            ...item,
            type: 'disciplines',
            value: `discipline-${parseInt(item.id)}`
        }));

        return {...(offering || {}), industries, skills, disciplines, brands};
    };

    if (!auth || !model) {
        return (
            <div className="p-5 flex flex-col items-center justify-center">
                <LoadingSpinner />
            </div>
        );
    }


    return (
        <Routes>

            <Route index element={
                <div>
                    <div className="form-title-section">
                        <div className="step-title-content">
                            <div>
                                <div className="flex items-center pb-4">
                                    <h3 className="form-title !mb-0">
                                        Service Offerings
                                    </h3>
                                </div>
                                <h5 className="form-subtitle">
                                    Define your agency's service offerings and capabilities
                                </h5>
                            </div>
                        </div>
                    </div>

                    {TB.map(model?.service_offerings || [], (offeringItem, offeringIndex) => {
                        const offering = getModelFromProps(offeringItem);
                        return (
                            <SupplierFormItemProvider
                                key={`service_offerings-${offering.id}-${offeringIndex}`}
                                itemIndex={offeringIndex}
                                preview={(
                                    <ProfileServiceRow
                                        service={offeringItem}
                                        keyClients={supplierOrg?.key_clients || []}
                                    />
                                )}
                                onChange={offeringProps => {
                                    let changedModel = TB.cloneDeep(offering);
                                    for (let [key, value] of Object.entries(offeringProps)) {
                                        changedModel = TB.set(changedModel, key, value);
                                    }
                                    return changedModel;
                                }}
                                onSave={async (serviceOfferingProps) => {
                                    console.log('serviceOfferingProps', serviceOfferingProps);

                                    const formatPropsForRequest = offering => {
                                        let tagTypes = ['disciplines', 'skills', 'industries'];
                                        let formatted = TB.pick(offering, [
                                            'id',
                                            ...tagTypes,
                                            'brands',
                                            'name',
                                            'tag_line',
                                            'summary',
                                            'process',
                                            'fee_type',
                                            'fee_amount',
                                            'assets',
                                            'image_path',
                                            'key_clients',
                                            'service_tags',
                                            'deliverables',
                                            'faqs',
                                            'display_index',
                                        ]);
                                        TB.map(tagTypes, type => {
                                            formatted[type] = TB.map(formatted[type] || [], item => TB.pick(item, ['id']));
                                        });
                                        formatted.brands = TB.map(formatted.brands || [], item => TB.pick(item, ['id', 'domain', 'name','icon','is_custom']));

                                        return formatted;
                                    };

                                    if (!serviceOfferingProps) {
                                        let offerings = TB.filter([...supplierOrg?.service_offerings], (serviceOffering, serviceOfferingIndex) => {
                                            return offeringIndex !== serviceOfferingIndex;
                                        });
                                        if (offering?.id) {
                                            offerings = TB.map(offerings, offering => formatPropsForRequest(offering));
                                            await onSave({service_offerings: offerings}, true);

                                            return setModel({service_offerings: offerings});
                                        }
                                        await onChange({service_offerings: offerings});
                                    } else {
                                        let offerings = TB.set([...supplierOrg?.service_offerings], offeringIndex, serviceOfferingProps);
                                        await onChange({service_offerings: offerings});
                                        await setEditingIndex(false);
                                        offerings = TB.map(offerings, offering => formatPropsForRequest(offering));

                                        await onSave({service_offerings: offerings}, true);

                                        return setModel({service_offerings: offerings});
                                    }
                                }}
                                model={offering}
                                isUpdating={isUpdating}
                                isEditing={false}
                                deleteEnabled={true}
                                canEdit={!isUpdating}
                                onEditing={(toggle) => {
                                    setEditingIndex(toggle ? offeringIndex : false);
                                    if (toggle) {
                                        return navigate(`${offeringIndex}`)
                                    }
                                }}
                                displayName="Service Offering"
                                itemPropName="service_offerings">

                                {/*<ServiceOfferingsForm />*/}

                            </SupplierFormItemProvider>
                        );
                    })}

                    <div
                        className={'white-panel talent-role-panel ' + (!!editingIndex && 'no-edit')}>
                        <button
                            disabled={false}
                            className="btn btn-outline-dark" onClick={() => addNewArrayProp('service_offerings')}>

                            Add Service Offering #{(supplierOrg?.service_offerings?.length || 0) + 1} <i className="ml-1 fa fa-plus"/>
                        </button>
                    </div>
                </div>
            } />
            <Route path=":serviceOfferingIndex/*" element={
                <ServiceOfferingWizardParent
                    supplierOrg={model}
                    isDisabled={isDisabled}
                    isUpdating={isUpdating}
                    onChange={(updates) => {
                        setModel(updates);
                    }}
                    onSave={async (params) => {
                        let updates = {...model}
                        for(let[key, value] of Object.entries(params)) {
                            updates = TB.set(updates, key, value);
                        }
                        await onEditItem(false)
                        await onSave(updates, true);
                    }}
                />
            }>
                <Route index element={<ServiceNameStep/>}/>
                <Route path="services" element={<ServiceCategoryStep/>}/>
                <Route path="overview" element={<OverviewStep />} />
                <Route path="search-tags" element={<SearchTagsStep />} />
                <Route path="deliverables" element={<DeliverablesStep />} />
                <Route path="faqs" element={<FAQsStep />} />
                <Route path="related-work" element={<RelatedProjectsStep />} />
                <Route path="*" element={<Navigate to={''}/>}/>
            </Route>
        </Routes>
    );
});

export default ServiceOfferingsStep;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};